import React from 'react';
import OtkOptionCatalogList from '../../../components/otk/OtkOptionCatalogList';

/** qlty034 — REMOTE_NON_PROGRESSIVE via shared OtkOptionCatalogList */
export default function RootCauseList() {
  return <OtkOptionCatalogList resource="root_causes" />;
}
